module.exports = __webpack_public_path__ + "img/marshallisland.96be3f74.svg";